module.exports = __webpack_public_path__ + "static/ghetto-bros-right-e65b40b17826874d4ddd4794c55d07f5.png";